"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfInquiryOrderProductSearchModel = instanceOfInquiryOrderProductSearchModel;
exports.InquiryOrderProductSearchModelFromJSON = InquiryOrderProductSearchModelFromJSON;
exports.InquiryOrderProductSearchModelFromJSONTyped = InquiryOrderProductSearchModelFromJSONTyped;
exports.InquiryOrderProductSearchModelToJSON = InquiryOrderProductSearchModelToJSON;
exports.InquiryOrderProductSearchModelToJSONTyped = InquiryOrderProductSearchModelToJSONTyped;
/**
 * Check if a given object implements the InquiryOrderProductSearchModel interface.
 */
function instanceOfInquiryOrderProductSearchModel(value) {
    return true;
}
function InquiryOrderProductSearchModelFromJSON(json) {
    return InquiryOrderProductSearchModelFromJSONTyped(json, false);
}
function InquiryOrderProductSearchModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderString': json['orderString'] == null ? undefined : json['orderString'],
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'iopFormNo': json['iopFormNo'] == null ? undefined : json['iopFormNo'],
    };
}
function InquiryOrderProductSearchModelToJSON(json) {
    return InquiryOrderProductSearchModelToJSONTyped(json, false);
}
function InquiryOrderProductSearchModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderString': value['orderString'],
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
        'iopFormNo': value['iopFormNo'],
    };
}
